import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isGoalEditable } from "web_myplann/Goals/Helpers/isGoalEditable";
import { useGoalAdvisorChat } from "web_myplann/Goals/Hooks/useGoalAdvisorChat";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type GoalActionLock = {
	blockedOpen: boolean;
	closeBlocked: () => void;
	requestEdit: () => void;
	onLockedAction: (() => void) | null;
	messageAdvisor: () => void;
};

export const useGoalActionLock = (
	goal: GoalDetail | undefined,
): GoalActionLock => {
	const { t } = useResource();
	const navigate = useNavigate();
	const openChat = useGoalAdvisorChat(goal);
	const [blockedOpen, setBlockedOpen] = useState(false);

	const openBlocked = () => setBlockedOpen(true);
	const lockedByAdvisor = goal !== undefined && !goal.allowEditByClient;

	const requestEdit = () => {
		if (!goal) {
			return;
		}
		if (!isGoalEditable(goal)) {
			openBlocked();
			return;
		}
		navigate(Routing.Goals.GoalFormEdit.path(Number(goal.id)));
	};

	const messageAdvisor = () => {
		setBlockedOpen(false);
		openChat(
			t(Resources.Goals.Detail.Blocked.advisorMessage, {
				goal: goal?.name ?? "",
			}),
		);
	};

	return {
		blockedOpen,
		closeBlocked: () => setBlockedOpen(false),
		requestEdit,
		onLockedAction: lockedByAdvisor ? openBlocked : null,
		messageAdvisor,
	};
};
